// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ApplicationController from "./application_controller"
application.register("application", ApplicationController)

import AppointmentsController from "./appointments_controller"
application.register("appointments", AppointmentsController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import CoursePriceController from "./course_price_controller"
application.register("course-price", CoursePriceController)

import DidacticController from "./didactic_controller"
application.register("didactic", DidacticController)

import DocumentationController from "./documentation_controller"
application.register("documentation", DocumentationController)

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import ExamController from "./exam_controller"
application.register("exam", ExamController)

import FocusController from "./focus_controller"
application.register("focus", FocusController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HistoricalController from "./historical_controller"
application.register("historical", HistoricalController)

import InstallmentsController from "./installments_controller"
application.register("installments", InstallmentsController)

import LuciaController from "./lucia_controller"
application.register("lucia", LuciaController)

import MagicController from "./magic_controller"
application.register("magic", MagicController)

import MaskCurrencyController from "./mask_currency_controller"
application.register("mask-currency", MaskCurrencyController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import OfficeController from "./office_controller"
application.register("office", OfficeController)

import PaymentsController from "./payments_controller"
application.register("payments", PaymentsController)

import PreloaderController from "./preloader_controller"
application.register("preloader", PreloaderController)

import SchoolController from "./school_controller"
application.register("school", SchoolController)

import SelectController from "./select_controller"
application.register("select", SelectController)

import SmallSubscriptionController from "./small_subscription_controller"
application.register("small-subscription", SmallSubscriptionController)

import StatsFiltersController from "./stats_filters_controller"
application.register("stats-filters", StatsFiltersController)

import SubscriptionsController from "./subscriptions_controller"
application.register("subscriptions", SubscriptionsController)

import TextareaController from "./textarea_controller"
application.register("textarea", TextareaController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import TogglerController from "./toggler_controller"
application.register("toggler", TogglerController)

import PerformanceHistoricalController from "../../components/stats/performance/historical_controller.js"
application.register("stats--performance--historical", PerformanceHistoricalController)
import PerformanceInvoicedController from "../../components/stats/performance/invoiced_controller.js"
application.register("stats--performance--invoiced", PerformanceInvoicedController)
import PerformanceProvinceController from "../../components/stats/performance/province_controller.js"
application.register("stats--performance--province", PerformanceProvinceController)